import img_1 from './images/Soundscape_background_1.jpg';
import img_2 from './images/Soundscape_background_2.jpg';
import img_3 from './images/Soundscape_background_3.jpg';
import img_4 from './images/Soundscape_background_4.jpg';
import img_5 from './images/Soundscape_background_5.jpg';
import img_6 from './images/Soundscape_background_6.jpg';

/* eslint-disable import/no-webpack-loader-syntax */
const slideScript_1 = require('raw-loader!./scripts/1.html');
const slideScript_2 = require('raw-loader!./scripts/2.html');
const slideScript_3 = require('raw-loader!./scripts/3.html');
const slideScript_4 = require('raw-loader!./scripts/4.html');
const slideScript_5 = require('raw-loader!./scripts/5.html');
const slideScript_6 = require('raw-loader!./scripts/6.html');

export const slideData = [

  {
    "index":0,
    "title": "1",
    "audio": "https://oca.no/anders-sunna-audio/AS_Venice_One.mp3",
    "image": img_1,
    "script": slideScript_1.default
  },

  {
    "index":1,
    "title": "2",
    "audio": "https://oca.no/anders-sunna-audio/AS_Venice_Two.mp3",
    "image": img_2,
    "script": slideScript_2.default
  },

  {
    "index":2,
    "title": "3",
    "audio": "https://oca.no/anders-sunna-audio/AS_Venice_Three.mp3",
    "image": img_3,
    "script": slideScript_3.default
  },

  {
    "index":3,
    "title": "4",
    "audio": "https://oca.no/anders-sunna-audio/AS_Venice_Four.mp3",
    "image": img_4,
    "script": slideScript_4.default
  },

  {
    "index":4,
    "title": "5",
    "audio": "https://oca.no/anders-sunna-audio/AS_Venice_Five.mp3",
    "image": img_5,
    "script": slideScript_5.default
  },

  {
    "index":5,
    "title": "6",
    "audio": "https://oca.no/anders-sunna-audio/AS_Venice_Six.mp3",
    "image": img_6,
    "script": slideScript_6.default
  },

]